import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

const CookieConsentBanner = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  useEffect(() => {
    const isArabic = currentLang === "ar";

    CookieConsent.run({
      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        analytics: {},
      },
      language: {
        default: isArabic ? "ar" : "en",
        translations: {
          en: {
            consentModal: {
              title: "We use cookies",
              description:
                "Panda website uses cookies to ensure proper functionality and to track your interactions. Accept or customize your preferences.",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Accept only necessary",
              showPreferencesBtn: "Manage preferences",
            },
            preferencesModal: {
              title: "Manage cookie preferences",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Accept only necessary",
              savePreferencesBtn: "Save settings",
              sections: [
                {
                  title: "Strictly necessary cookies",
                  description:
                    "These cookies are essential for the website to function properly.",
                  linkedCategory: "necessary",
                },
                {
                  title: "Performance and Analytics cookies",
                  description:
                    "These cookies help us understand how our website is used.",
                  linkedCategory: "analytics",
                },
                {
                  title: "More Information",
                  description:
                    "For more details on our cookie usage, please contact us.",
                },
              ],
            },
          },
          ar: {
            consentModal: {
              title: "نحن نستخدم ملفات تعريف الارتباط",
              description:
                "يستخدم موقع بنده ملفات تعريف الارتباط لضمان الوظائف المناسبة وتتبع تفاعلاتك. قبول أو تخصيص تفضيلاتك.",
              acceptAllBtn: "قبول الكل",
              acceptNecessaryBtn: "قبول الضرورية فقط",
              showPreferencesBtn: "إدارة التفضيلات",
            },
            preferencesModal: {
              title: "إدارة تفضيلات ملفات تعريف الارتباط",
              acceptAllBtn: "قبول الكل",
              acceptNecessaryBtn: "قبول الضرورية فقط",
              savePreferencesBtn: "حفظ الإعدادات",
              sections: [
                {
                  title: "ملفات تعريف الارتباط الضرورية للغاية",
                  description:
                    "هذه الملفات ضرورية لضمان الوظيفة الصحيحة للموقع.",
                  linkedCategory: "necessary",
                },
                {
                  title: "ملفات تعريف الارتباط للأداء والتحليلات",
                  description:
                    "تساعدنا هذه الملفات على فهم كيفية استخدام الموقع.",
                  linkedCategory: "analytics",
                },
                {
                  title: "مزيد من المعلومات",
                  description:
                    "للمزيد من التفاصيل حول استخدامنا لملفات تعريف الارتباط، يرجى التواصل معنا.",
                },
              ],
            },
          },
        },
      },
      gui_options: {
        consent_modal: {
          layout: "box", // Banner layout
          position: "bottom", // Position: 'bottom', 'top', 'bottom-left', 'bottom-right'
          transition: "slide", // Animation style for opening the banner
          swap_buttons: isArabic, // Swap buttons for RTL languages like Arabic
        },
        settings_modal: {
          layout: "bar", // Layout for the settings modal (also box or bar)
        },
      },
    });
  }, [currentLang]);

  return null; // This component doesn't need to render anything visually
};

export default CookieConsentBanner;
